import { Container } from '@isbj-redesign/frontend-components'
import React from 'react'
import BereitstellungenTable from './BereitstellungenTable'
import DokumenteTable from './DokumenteTable'
import Layout from './Layout'

export default function DokumentePage() {
    return (
        <Layout title="Dokumente">
            <Container fluid>
                <BereitstellungenTable />
                <DokumenteTable />
            </Container>
        </Layout>
    )
}
